<div class="main-table">
    <div class="main-table-toolbar">
        <div class="main-toolbar-container">
            <div class="main-toolbar-add">
                <button
                    mat-stroked-button
                    (click)="addEditor()"
                    matTooltip="{{ 'add_user_tooltip' | transloco }}"
                >
                    <mat-icon>add</mat-icon>
                    {{ "new_record" | transloco }}
                </button>
            </div>
            <div class="main-toolbar-spacer"></div>
            <div class="main-toolbar-filter-container">
                <div class="main-toolbar-filter">
                    <div class="filter-item">
                        <pixl-free-filter-input
                            [label]="'email-address_or_id' | transloco"
                            [matIcon]="'search'"
                            [hint]="getSearchFilterHint()"
                            [minLength]="freeFilterLen"
                            (onKeyUpChange)="setFreeFilter($event)"
                        />
                    </div>
                    <div class="filter-item">
                        <mat-form-field>
                            <mat-label>{{ "role" | transloco }}</mat-label>
                            <mat-select multiple (valueChange)="setRoleFilter($event)">
                                <mat-option [value]="''">---</mat-option>
                                <mat-option [value]="'author'">{{ "author" | transloco }}</mat-option>
                                <mat-option [value]="'editor'">{{ "editor" | transloco }}</mat-option>
                                <mat-option [value]="'appAdmin'">{{ "appAdmin" | transloco }}</mat-option>
                                <mat-option [value]="'zavAdmin'">{{ "zavAdmin" | transloco }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div class="main-toolbar-spacer-right"></div>
        </div>
        <div class="table-header-overlay"></div>
    </div>

    <div class="table-container mat-elevation-z4">
        @if (editors$ | async; as editors) {
            <table
                mat-table
                [dataSource]="editors"
                matSort
                (matSortChange)="announceSortChange($event)"
            >
                <ng-container matColumnDef="edit-actions">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >{{ "actions" | transloco }}</th>
                    <td
                        mat-cell
                        *matCellDef="let editor"
                        class="action-column no-wrap"
                    >
                        <button
                            [class.btn-success]="coloredButtonsEnabled()"
                            mat-icon-button
                            color="primary"
                            aria-label="Edit"
                            (click)="editEditor(editor)"
                            matTooltip="{{ 'edit_record_hint' | transloco }}"
                        >
                            <mat-icon>edit</mat-icon>
                        </button>
                        @if (this.authState().editor?.email !== editor.email) {
                            <button
                                [class.btn-danger]="coloredButtonsEnabled()"
                                mat-icon-button
                                color="warn"
                                aria-label="Delete"
                                matTooltip="{{ 'delete_record_hint' | transloco }}"
                                (click)="deleteEditor(editor)"
                            >
                                <mat-icon>delete</mat-icon>
                            </button>
                        }
                    </td>
                </ng-container>

                <ng-container matColumnDef="id">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                        mat-sort-header
                    >ID</th>
                    <td
                        mat-cell
                        *matCellDef="let editor"
                    >{{ editor.id }}</td>
                </ng-container>

                <ng-container matColumnDef="email">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                        mat-sort-header
                    >{{ "email-address" | transloco }}</th>
                    <td
                        mat-cell
                        *matCellDef="let editor"
                    >{{ editor.email }}</td>
                </ng-container>

                <ng-container matColumnDef="role">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                        mat-sort-header
                    >{{ "role" | transloco }}</th>
                    <td
                        mat-cell
                        *matCellDef="let editor"
                        class="no-wrap"
                    >
                        {{ getEditorRole(editor.role) }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="updated">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                        mat-sort-header
                    >{{ "updated" | transloco }}</th>
                    <td
                        mat-cell
                        *matCellDef="let editor"
                    >
                        {{ getCreatedDate(editor.id) | date }}
                    </td>
                </ng-container>

                <tr
                    mat-header-row
                    *matHeaderRowDef="displayedColumns; sticky: true"
                ></tr>
                <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumns"
                    [class.selected-row]="currentSelectedRow() === row.id"
                ></tr>
            </table>
        } @else {
            <pixl-table-loading-spinner [name]="'users' | transloco" />
        }
        <mat-paginator
            [pageIndex]="pageChange().pageIndex"
            [pageSize]="pageChange().pageSize"
            [pageSizeOptions]="[25, 50, 100]"
            [length]="totalItems">
        </mat-paginator>
    </div>
</div>